export const formattedRedirectAfterLogin = (url, host, hash) => {
  return `${url}?redirect_url=${host}#${hash}/`
}

export const formattedRedirectLogout = (url, host, hash) => {
  return `${url}logout/?redirect_url=${host}#${hash}/`
}
